/* M-Bossed: Defer cart drawer only during add-to-cart */
(function() {
  var addingToCart = false;
  var observer = null;
  var fallbackTimer = null;
  var origShowModal = HTMLDialogElement.prototype.showModal;
  var origShow = HTMLDialogElement.prototype.show;

  function isCartDrawerDialog(dialog) {
    return dialog.closest('cart-drawer-component') !== null;
  }

  function hasCartItems(dialog) {
    return dialog.querySelector('tr[ref], .cart-items__table-row, cart-quantity-selector-component') !== null;
  }

  function doOpen(dialog) {
    addingToCart = false;
    if (observer) { observer.disconnect(); observer = null; }
    if (fallbackTimer) { clearTimeout(fallbackTimer); fallbackTimer = null; }
    try { origShowModal.call(dialog); } catch(e) {}
  }

  function waitAndOpen(dialog) {
    if (hasCartItems(dialog)) {
      doOpen(dialog);
      return;
    }

    observer = new MutationObserver(function() {
      if (hasCartItems(dialog)) {
        doOpen(dialog);
      }
    });
    observer.observe(dialog, { childList: true, subtree: true, attributes: true });

    fallbackTimer = setTimeout(function() {
      doOpen(dialog);
    }, 4000);
  }

  // Detect add-to-cart button clicks
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('add-to-cart-component, [name="add"], button[type="submit"]');
    if (btn && btn.closest('product-form-component, form[action*="/cart/add"]')) {
      addingToCart = true;
      // Reset after 5s in case something goes wrong
      setTimeout(function() { addingToCart = false; }, 5000);
    }
  }, true);

  HTMLDialogElement.prototype.showModal = function() {
    if (isCartDrawerDialog(this) && addingToCart) {
      waitAndOpen(this);
      return;
    }
    return origShowModal.call(this);
  };

  HTMLDialogElement.prototype.show = function() {
    if (isCartDrawerDialog(this) && addingToCart) {
      waitAndOpen(this);
      return;
    }
    return origShow.call(this);
  };
})();
